import { ObservableArray, View } from "binder"
import { AccessManagementViewModel, IForm, UserViewModel } from "./accessManagement-viewModel"
import { ITreeFilter } from "src/uicomponents/components/tree/tree-viewModel";

export class AccessManagementView extends View<AccessManagementViewModel>{
    GetViewUniqueId(): string {
        return "V-D30406FE-1C46-4179-912E-AA2A60F3DCF4"
    }
    loadHtml(): string {
        let element = require('./accessManagement.html').default;
        let style = require('./accessManagement.less');
        return element;
    }
    constructor() {
       super();
       this.filterEvaluator = new Filter();
    }

    public set isLoading(v: boolean) { this._isLoading = v; } public get isLoading(): boolean { return this._isLoading;} private _isLoading: boolean;
    public set users(v: ObservableArray<UserViewModel>) { this._users = v; } public get users(): ObservableArray<UserViewModel> { return this._users;} private _users: ObservableArray<UserViewModel>;
    public set allForms(v: ObservableArray<IForm>) { this._allForms = v; } public get allForms(): ObservableArray<IForm> { return this._allForms;} private _allForms: ObservableArray<IForm>;
    public set filteredUsers(v: ObservableArray<UserViewModel>) { this._filteredUsers = v; } public get filteredUsers(): ObservableArray<UserViewModel> { return this._filteredUsers; } private _filteredUsers: ObservableArray<UserViewModel>;
    public set searchedUserNameText(v: string) { this._searchedUserNameText = v; } public get searchedUserNameText(): string { return this._searchedUserNameText;} private _searchedUserNameText: string;
    public set filterEvaluator(v: ITreeFilter) { this._filterEvaluator = v; } public get filterEvaluator(): ITreeFilter { return this._filterEvaluator;} private _filterEvaluator: ITreeFilter;
    

    refresh(){
        this.dataContext.refresh();
    }

    save(){
        this.dataContext.save()
    }
}

class Filter implements ITreeFilter{
    filter(item: any, searchText: string): boolean {
        return (<IForm>item).name.toLowerCase().includes(searchText.toLowerCase());
    }

}
